import Vue from 'vue'
import Vuex, {StoreOptions} from 'vuex'
import CountModule from "@/store/CountModule";
import {RootState} from "@/store/types";
import OrdersModule from "@/store/Orders/OrdersModule";
import CustomerModule from "@/store/Customer/CustomerModule";
import LoadingModule from "@/store/Loading/LoadingModule";
import CompareModule from "@/store/Compare/CompareModule";

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    count: CountModule,
    orders: OrdersModule,
    customer: CustomerModule,
    loading: LoadingModule,
    compare: CompareModule
  }
}

export default new Vuex.Store<RootState>(store);
